import { useContext } from 'react';

import { ConnectFormContext } from '../ConnectFormContext';

export default function useConnectForm() {
  const context = useContext(ConnectFormContext);

  if (!context) {
    throw new Error(
      'useConnectForm must be used within a ConnectFormContext.Provider'
    );
  }

  return context;
}
